var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-text',[_c('h3',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.title))]),_c('GChart',{staticClass:"px-2",attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }